export const allBlogPosts = [
  {
    slug: "the-future-of-techpacks",
    title: "The Future of Techpacks",
    img: "https://images.pexels.com/photos/3862377/pexels-photo-3862377.jpeg",
    date: "November 8, 2025",
    description: "Learn about the next wave of innovation in digital fashion and techpack creation.",
    fullContent: `
      <p>The fashion industry is on the verge of a digital revolution. For decades, the techpack has been the universal language between designer and manufacturer, but it has largely remained a static document.</p>
      <br/>
      <p>Now, with the rise of 3D design tools like Clo3D and advanced PLM (Product Lifecycle Management) systems, the "techpack" is evolving from a simple PDF into a living, breathing, 3D file. This means faster prototyping, fewer errors, and a more sustainable process. We are at the forefront of this change, integrating 3D assets directly into our techpack services to give our clients a competitive edge.</p>
    `
  },
  {
    slug: "A.I. and Fashion Industry",
    title: "A.I. and Fashion Industry",
    img: "https://images.pexels.com/photos/8438965/pexels-photo-8438965.jpeg",
    date: "November 1, 2025",
    description: "How Artificial Intelligence(A.I.) is transforming Fashion Industry.",
    fullContent: `
      <p>As an India-based service, 99% of our clients are from the US, UK, Australia, and beyond. We have built our entire process around clear, concise, and constant communication.</p>
      <br/>
      <p>The key is a flawless techpack. It removes ambiguity and acts as a single source of truth, no matter what time zone you're in. We leverage tools like Adobe Illustrator for precise vector files and Clo3D for 3D sampling to ensure you see *exactly* what you're getting, long before the first sample is even sewn.</p>
    `
  },
  {
    slug: "behind-the-scenes-of-fashion-tech",
    title: "Behind the Scenes of Fashion Tech",
    img: "https://images.pexels.com/photos/25194063/pexels-photo-25194063.jpeg",
    date: "October 25, 2025",
    description: "A look at the tools we use, from Adobe Illustrator to Clo3D, to create your garments.",
    fullContent: `
      <p>Many clients are surprised by the amount of technology that goes into creating a simple garment. It's not just sketches on paper.</p>
      <br/>
      <p>Our workflow is 100% digital. We use Adobe Illustrator for all flat sketches, vector files, and logo designs. We use CorelDRAW for complex pattern layouts. And increasingly, we use Clo3D to create a digital, 3D version of your garment that you can review and approve on your computer. This saves weeks of time and thousands of dollars in sample shipping costs. A modern techpack is a file, a 3D model, and a blueprint all in one.</p>
    `
  }
];